














import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class CollapsibleCard extends Vue {
  @Prop(Boolean)
  public expanded?: boolean;
  public isOpen: boolean = false;

  public beforeMount(): void {
    this.isOpen = !!this.expanded;
  }

  public toggleContent(): void {
    this.isOpen = !this.isOpen;
  }
}
